export const EBON_ACTIVATION_TYPE_ONLINE = 'ONLINE';
export const EBON_ACTIVATION_TYPE_OFFLINE = 'OFFLINE';
export const EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE = 'ONLINE_AND_OFFLINE';

export const EBON_TYPE_DOWNLOAD_CODE = 'DOWNLOAD_CODE';
export const EBON_TYPE_LINK_CODE = 'LINK_CODE';

export const DEFAULT_FIXED_FACIAL_VALUES = [
    { facialValue: 30, quantityAvailable: 20, expirationDate: 32503680000000 },
    { facialValue: 50, quantityAvailable: 20, expirationDate: 32503680000000 },
    { facialValue: 100, quantityAvailable: 20, expirationDate: 32503680000000 },
    { facialValue: 200, quantityAvailable: 20, expirationDate: 32503680000000 }
];



// WEBPACK FOOTER //
// ./src/constants/ebon.js